/* Product card (fs-card-floor): photo carousel, chip chevrons. Delegated (works for Load more cards).
   Idle until a card is hovered, touched, focused or clicked; extra photos load then.
   The save heart [data-fs-heart] is handled by assets/fs-saved.js (loaded from the header). */
(() => {
  if (window.FSCard) return;
  window.FSCard = 1;
  const d = document;
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const cardOf = (el) => el?.closest?.('[data-fs-card]');

  // few = 1: a touch only primes the next photo (thumbs rest on cards while scrolling the page on phones – waking
  // every touched card downloaded 4 extra photos each); a swipe, arrow or dot click loads the rest.
  const wake = (card, few) => {
    if (!card || card.dataset.carOn) return;
    if (!few) card.dataset.carOn = 1;
    const sizes = card.querySelector('img:not([data-src])')?.sizes || '100vw';
    [...card.querySelectorAll('img[data-src]')].slice(0, few || 99).forEach((img) => {
      const src = img.dataset.src;
      img.sizes = sizes;
      img.srcset = [300, 450, 600, 750, 900].map((w) => `${src.replace(/width=\d+/, 'width=' + w)} ${w}w`).join();
      img.src = src;
      delete img.dataset.src;
    });
  };
  const at = (track) => Math.round(track.scrollLeft / (track.clientWidth || 1));

  d.addEventListener('pointerover', (e) => e.pointerType == 'mouse' && wake(cardOf(e.target)), { passive: true });
  d.addEventListener('touchstart', (e) => wake(cardOf(e.target), 1), { passive: true });
  d.addEventListener('focusin', (e) => e.target.matches?.('.fs-card__car-btn') && wake(cardOf(e.target)));

  d.addEventListener('click', (e) => {
    const t = e.target.closest?.('[data-car],[data-car-to],[data-chips]');
    const card = cardOf(t);
    if (!card) return;
    e.preventDefault();
    const ds = t.dataset;
    if (ds.chips) {
      const row = card.querySelector('.fs-card__chips-row');
      row.scrollBy({ left: ds.chips * row.clientWidth * 0.7, behavior: smooth });
    } else {
      wake(card);
      const track = card.querySelector('.fs-card__car-track');
      const n = track.children.length;
      const i = ds.carTo != null ? +ds.carTo : at(track) + +ds.car;
      track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: smooth });
    }
  });

  // scroll doesn't bubble: one capturing listener, at most one update per frame
  let queued;
  d.addEventListener(
    'scroll',
    (e) => {
      const el = e.target;
      const car = el.classList?.contains('fs-card__car-track');
      if (queued == el || !(car || el.classList?.contains('fs-card__chips-row'))) return;
      queued = el;
      requestAnimationFrame(() => {
        queued = null;
        if (car) {
          const i = at(el);
          wake(cardOf(el));
          el.parentElement.querySelectorAll('.fs-card__car-dot').forEach((dot, k) => dot.setAttribute('aria-current', k == i));
        } else {
          const box = el.parentElement.dataset;
          box.prev = +(el.scrollLeft > 2);
          box.next = +(el.scrollLeft < el.scrollWidth - el.clientWidth - 2);
        }
      });
    },
    { capture: true, passive: true }
  );
})();
